import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./SupportPage.css";
import Logo from "../img/logo.png";
import bgImage from "../img/blog_background.png";

import berlin from '../img/company/berlin.png'
import esf from '../img/company/esf.jpg'
import hwr from '../img/company/hwr.png'
import sib from '../img/company/sib.jpg'

// Import support images
import onboardingImage from "../img/support_onboarding.png";
import emailSupportImage from "../img/support_email.png";
import documentationImage from "../img/support_documentation.png";
import { useNavigate, useLocation } from "react-router-dom";

function SupportPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
      }, 100); // small delay for page to render
    } else {
      document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>Support - Revexia | Help Center & Documentation</title>
        <meta
          name="description"
          content="Get help with Revexia. Access our comprehensive documentation, support channels, and connect with our team."
        />
      </Helmet>

      <div className="support-page">
        {/* Navigation */}
         <nav className="navbar-custom">
          <div className="navbar-container">
            {/* Logo Section */}
            <div className="navbar-brand-custom">
              <Link to="/">
                <img src={Logo} alt="Revexia Logo" className="navbar-logo-img" />
              </Link>
            </div>

            {/* Center Navigation Pills */}
            <div className="navbar-center-pill">
              <ul className="nav-menu-pills">
                <li className="nav-item-pill">
                  <Link to="/" className="nav-link-pill">
                    Home
                  </Link>
                </li>
                <li className="nav-item-pill">
                  <a href="/#features" className="nav-link-pill" onClick={handleClick}>
                    Feature
                  </a>
                </li>

                <li className="nav-item-pill nav-item-dropdown">
                  <button className="nav-link-pill nav-dropdown-toggle">
                    Resources
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="dropdown-arrow"
                    >
                      <path
                        d="M1 1L5 5L9 1"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <div className="nav-dropdown-menu">
                    <Link to="/how" className="nav-dropdown-item">
                      How it works
                    </Link>
                    <Link to="/support" className="nav-dropdown-item">
                      Support overview
                    </Link>
                    <Link to="/trust" className="nav-dropdown-item">
                      Trust Center
                    </Link>
                    <Link to="/privacy-policy" className="nav-dropdown-item">
                      Privacy Policy
                    </Link>
                    <Link to="/terms" className="nav-dropdown-item">
                      Terms of Service
                    </Link>
                     <Link to="/facebook-terms" className="nav-dropdown-item">
                                          Facebook Terms
                                        </Link>
                  </div>
                </li>
                <li className="nav-item-pill">
                  <Link to="/blog" className="nav-link-pill">
                    Blog
                  </Link>
                </li>
                
              </ul>
            </div>

            {/* Right Side - Auth Buttons */}
            <div className="navbar-auth-section">
              {user ? (
                <>
                  <Link to="/dashboard" className="btn-nav-outline">
                    Dashboard
                  </Link>
                  <button onClick={handleLogout} className="btn-nav-gradient">
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/join-waitlist" className="btn-nav-gradient">
                                     Get Started
                                   </Link>
                                     <Link to="/auth" className="btn-nav-gradientlogin">
                                     Login
                                   </Link>
                </>
              )}
            </div>

            {/* Mobile Toggle */}
            <button
              className="navbar-mobile-toggle"
              type="button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span className="navbar-toggler-icon-custom"></span>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="navbar-mobile-menu">
              <ul className="mobile-nav-list">
                <li>
                  <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                    Home
                  </Link>
                </li>

                <li >
                  <a href="/#features" onClick={(e) => {
                      setMobileMenuOpen(false);
                      handleClick(e);
                    }} >
                    Feature
                  </a>
                </li>
                
                <li>
                  <Link to="/how" onClick={() => setMobileMenuOpen(false)}>
                    How it works
                  </Link>
                </li>
                <li>
                  <Link to="/support" onClick={() => setMobileMenuOpen(false)}>
                    Support overview
                  </Link>
                </li>
                <li>
                  <Link to="/trust" onClick={() => setMobileMenuOpen(false)}>
                    Trust Center
                  </Link>
                </li>
                <li>
                  <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>
                    Blog
                  </Link>
                </li>
                
              </ul>
              <div className="mobile-auth-buttons">
                {user ? (
                  <>
                    <Link
                      to="/dashboard"
                      className="btn-nav-outline"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Dashboard
                    </Link>
                    <button
                      onClick={() => {
                        handleLogout();
                        setMobileMenuOpen(false);
                      }}
                      className="btn-nav-gradient"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="/auth"
                      className="btn-nav-gradient"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Login
                    </Link>
                  </>
                )}
              </div>
            </div>
          )}
        </nav>

        {/* Main Content */}
        <main className="support-main">
          {/* Hero Section with Background */}
          <section className="support-hero-section">
            {/* Background Effects */}
            <div className="support-hero-bg-effects">
              <div className="support-hero-bg-image-wrapper">
                <img
                  src={bgImage}
                  alt=""
                  className="support-hero-bg-image"
                />
              </div>
              <div className="support-hero-gradient-overlay"></div>
            </div>

            {/* Hero Content */}
            <div className="support-hero-content">
              <h1 className="support-hero-title">Support overview</h1>
              <p className="support-hero-subtitle">
                Your growth matters to us and we are wholeheartedly committed
                to your success.
              </p>
            </div>
          </section>

          {/* Support Channels Section */}
          <section className="support-channels-section">
            <div className="support-channels-container">
              <div className="support-section-label">SUPPORT CHANNELS</div>

              <div className="support-options-grid">
                {/* Option 1: Onboarding */}
                <div className="support-option-card">
                  <div className="support-option-image-wrapper">
                    <img
                      src={onboardingImage}
                      alt="Onboarding Specialist"
                      className="support-option-image"
                    />
                  </div>
                  <div className="support-option-content">
                    <h3 className="support-option-title">Onboarding</h3>
                    <p className="support-option-description">
                      As you get started with Revexia, a member of our
                      onboarding team can directly help your business, providing
                      best practices and strategic recommendations.
                    </p>
                  </div>
                </div>

                {/* Option 2: Email & Chat Support */}
                <div className="support-option-card">
                  <div className="support-option-image-wrapper">
                    <img
                      src={emailSupportImage}
                      alt="Email Support"
                      className="support-option-image"
                    />
                  </div>
                  <div className="support-option-content">
                    <h3 className="support-option-title">
                      Email and chat support
                    </h3>
                    <p className="support-option-description">
                      Connect with Revexia support team members by email to
                      answer your product and technical questions.
                    </p>
                    <div className="support-status-badge">
                      <span className="status-dot"></span>
                      <span className="status-text">Email: 24/7+</span>
                    </div>
                  </div>
                </div>

                {/* Option 3: Documentation */}
                <div className="support-option-card">
                  <div className="support-option-image-wrapper">
                    <img
                      src={documentationImage}
                      alt="Documentation"
                      className="support-option-image"
                    />
                  </div>
                  <div className="support-option-content">
                    <h3 className="support-option-title">
                      Documentation & Guides
                    </h3>
                    <p className="support-option-description">
                      Explore our comprehensive knowledge base, API references,
                      and step-by-step video tutorials to help you build faster.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Common Questions Section */}
          <section className="support-faq-section">
            <div className="support-faq-container">
              <div className="support-section-label">COMMON QUESTIONS</div>

              <div className="support-faq-grid">
                {/* Question 1 */}
                <div className="faq-item">
                  <h4 className="faq-question">
                    What is the typical response time?
                  </h4>
                  <p className="faq-answer">
                    For Enterprise plans, our average response time is under 2
                    hours. Standard plans typically receive a response within 1
                    business day.
                  </p>
                </div>

                {/* Question 2 */}
                <div className="faq-item">
                  <h4 className="faq-question">Do you offer phone support?</h4>
                  <p className="faq-answer">
                    We focus on chat and email to provide detailed technical
                    assistance, but scheduled video calls are available for
                    Onboarding and Enterprise tiers.
                  </p>
                </div>

                {/* Question 3 */}
                <div className="faq-item">
                  <h4 className="faq-question">
                    Where can I check system status?
                  </h4>
                  <p className="faq-answer">
                    You can view real-time performance metrics and maintenance
                    schedules on our status page linked below.
                  </p>
                </div>

                {/* Question 4 */}
                <div className="faq-item">
                  <h4 className="faq-question">
                    Can I hire a dedicated technical account manager?
                  </h4>
                  <p className="faq-answer">
                    Yes, dedicated account management is included with all
                    Enterprise agreements to ensure your long-term success.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
<section className="cta-section-final" id="cta">
          <style>{`
            .logo-marquee-wrapper {
              position: relative;
              width: 100%;
              max-width: 100%;
              overflow: hidden;
              margin-top: 48px;
              padding: 16px 0;
            }

            .logo-marquee-track {
              display: flex;
              width: max-content;
              animation: logo-marquee-scroll 30s linear infinite;
              will-change: transform;
            }

            .logo-marquee-group {
              display: flex;
              align-items: center;
              flex-shrink: 0;
            }

            .logo-marquee-item-box {
              width: 160px;
              height: 56px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
            }

            .logo-marquee-item {
              height: 36px;
              width: auto;
              max-width: 140px;
              object-fit: contain;
              opacity: 0.85;
              transition: opacity 0.3s ease;
              display: block;
            }

            .logo-marquee-item:hover {
              opacity: 1;
            }

            @keyframes logo-marquee-scroll {
              from {
                transform: translateX(0);
              }
              to {
                transform: translateX(-25%);
              }
            }
          `}</style>

          <div className="container-cta-final">
            {/* Purple Gradient Blur Background */}
            <div className="cta-gradient-blur"></div>
            {/* CTA Content */}
            <div className="cta-content-wrapper">
              {/* Heading Container */}
              <div className="cta-heading-container">
                <h2 className="cta-main-heading">
                  Start Building Your AI Revenue Brain Today.
                </h2>
              </div>
              {/* Subheading Container */}
           
              {/* CTA Buttons */}
              <div className="cta-buttons-wrapper">
                {/* Primary CTA Button - Get Started */}
                
                  <Link to="/auth" className="contact-btn-primary">
                    <span className="cta-button-text">Get started</span>
                   </Link>
                  
             
                {/* Secondary CTA Button - Watch Demo */}
                <button className="cta-button-secondary">
                  {/* Gradient Overlay */}
                  <div className="button-gradient-overlay"></div>
                  {/* Horizontal Divider */}
                  <div className="button-horizontal-divider"></div>
                  {/* Animated Dots */}
                  <div className="button-dot-glow dot-1"></div>
                  <div className="button-dot-normal dot-2"></div>
                  <div className="button-dot-small dot-3"></div>
                  {/* Button Content */}
                  <div className="cta-button-content">
                    <svg
                      className="play-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M3.33325 2L12.6666 8L3.33325 14V2Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="1.33"
                      />
                    </svg>
                    <a
  href="https://www.youtube.com/watch?v=G7D5c40whQA"
  target="_blank"
  rel="noopener noreferrer"
  style={{ color: "black" }}
>
  <span className="cta-button-text-secondary">
    What is Revexia
  </span>
</a>
                  </div>
                </button>
              </div>
              {/* Partner Logos Marquee - Scrolling Ticker */}
              <div className="logo-marquee-wrapper">
                <div className="logo-marquee-track">
                  {[0, 1, 2, 3].map((groupIndex) => (
                    <div
                      className="logo-marquee-group"
                      key={groupIndex}
                      aria-hidden={groupIndex !== 0}
                    >
                      <div className="logo-marquee-item-box">
                        <img
                          src={berlin}
                          alt={groupIndex === 0 ? "Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={esf}
                          alt={groupIndex === 0 ? "European Social Fund" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={hwr}
                          alt={groupIndex === 0 ? "HWR Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={sib}
                          alt={groupIndex === 0 ? "Startup Incubator Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        </main>

        {/* Footer */}
        <footer className="footer-v2" id="contact">
          <div className="container-footer-v2">
            <div className="footer-main-content">
              <div className="footer-brand-section-v2">
                <div className="footer-logo-wrapper">
                  <img
                    src={Logo}
                    alt="Revexia"
                    className="footer-logo-image"
                  />
                </div>
                <p className="footer-brand-description-v2">
                  A platform to turn social media DM engagement into automated
                  revenue with AI-driven personalization.
                </p>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Informations</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  
                </ul>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Social</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <a
                      href="https://www.facebook.com/share/1AhWEt4FyM/?mibextid=wwXIfr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/revexia.ai/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Instagram
                    </a>
                  </li>
                  
                  <li>
                    <a
                      href="https://www.linkedin.com/company/revexiaai/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/revexia.ai"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      TikTok
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Help</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  
                  <li>
                    <Link to="/terms">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                   <li>
                                      <Link to="/facebook-terms">Facebook Terms</Link>
                                    </li>
                </ul>
              </div>
            </div>

            <hr className="footer-divider-line-v2" />

            <div className="footer-bottom-v2">
              <p className="footer-copyright-v2">
                ©2026 Revexia. All rights reserved. Developed by{" "}
                <a
                  href="https://softwarebari.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="developer-link"
                >
                  Softwarebari
                </a>
                .
              </p>
              <div className="footer-legal-links-v2">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <span className="separator-v2">|</span>
                <Link to="/terms">Terms & Conditions</Link>
                <span className="separator-v2">|</span>
                <Link to="/cookies">Cookies Policy</Link>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default SupportPage;
